<section class="admin-login-page">
  <div class="admin-login-page__overlay">
    <div class="admin-login-page__card">
      <div class="admin-login-page__intro">
        <p class="eyebrow">Bourne Bespoke</p>
        <h1>Admin Login</h1>
        <p>Sign in to access the Bourne Bespoke admin panel.</p>
      </div>

      <axis-form formType="login" [showLabels]="true"></axis-form>
    </div>
  </div>
</section>
